// JavaScript Document

// Load TrustedForms script
(function () {
    var field = 'xxTrustedFormCertUrl';
    var provideReferrer = false;
    var invertFieldSensitivity = false;
    var tf = document.createElement('script');
    tf.type = 'text/javascript';
    tf.async = true;
    tf.src = 'http' + ('https:' == document.location.protocol ? 's' : '') + '://cfptwebapi.cfdomains.com/trustedform.js?provide_referrer=' + escape(provideReferrer) + '&field=' + escape(field) + '&l=' + new Date().getTime() + Math.random() + '&invert_field_sensitivity=' + invertFieldSensitivity;
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(tf, s);
})();

(function ($) {

    'use strict';

    Array.prototype.count = function () {
        return this.length;
    };

    var $leadForm = $(document, '#lead-form'),
        zipCode = 0,
        $_GET = [],
        totalStepCount = Object.keys(window.leadFormData).length;

    function forceNumeric()
    {

        var $input = $(this);
        $input.val($input.val().replace(/[^\d]+/g, ''));

    }

    function triggerTrackingSteps(step, direction)
    {
        const defaultData = {
            'event': 'lead_form_step',
            'leadFormId': 'housing-finder-form',
            'leadFormStep': step,
            'leadFormStepDirection': direction,
        };
        window.dataLayer.push(defaultData);
        console.log(defaultData);
    }

    function submitLytics(formSubmissionData)
    {

        let fields = {};
        $.each(formSubmissionData, function (i, field) {
            fields[field.name] = field.value;
        });

        const lyticsVars = {
            'domainVisited' : window.location.protocol+'//'+ window.location.hostname + '/',
            'lastPageVisited' : window.location.pathname,
            'email' : fields['email_address'],
            'first_name': fields['first_name'],
            'last_name': fields['last_name'],
            'phone' : fields['phone_home'],
            'zip' : fields['zip_code'],
            'q_interest' : fields['careTypeCode'],
            'q_relationship_name' : fields['relationToResident'],
            'q_timeframe' : fields['moveDateRange'],
            'q_financial' : fields['financialResources'],
            'q_cost' : fields['budget'],
            'dataStream' : 'theseniorlist_seo',
        }

        if (window.cfLytics && typeof(window.cfLytics) === 'function'
            && window.jstag && typeof(window.jstag.getEntity) === 'function') {
            window.cfLytics(lyticsVars);
        } else {
            window.dataLayer.push({
                'event': 'cfLyticsIsNotDefined',
            });
        }
    }

    function validatePhone(myForm)
    {
        var fphone = jQuery('.phone_number', myForm).val();
        var errormsg = 'Sorry, that is not a valid area code.';

        if (fphone != '') {
            fphone = fphone.replace(/[^\d]/g, '')
            if (fphone.match('^0')) {
                jQuery('.invalid-number').text(errormsg);
                jQuery('.form__btn').attr('disabled', false).removeClass('loading');
                jQuery('.fa-spin').hide();
                return false;
            }
            if (fphone.match('^1')) {
                jQuery('.invalid-number').text(errormsg);
                jQuery('.form__btn').attr('disabled', false).removeClass('loading');
                jQuery('.fa-spin').hide();
                return false;
            }
            if (fphone.match('^999') || fphone.match('^888') || fphone.match('^777') || fphone.match('^666') || fphone.match('^555') || fphone.match('^444') || fphone.match('^333') || fphone.match('^222') || fphone.match('^111')) {
                jQuery('.invalid-number').text(errormsg);
                jQuery('.form__btn').attr('disabled', false).removeClass('loading');
                jQuery('.fa-spin').hide();
                return false;
            }
            if (fphone.match(/0000$/)) {
                jQuery('.invalid-number').text(errormsg);
                jQuery('.form__btn').attr('disabled', false).removeClass('loading');
                jQuery('.fa-spin').hide();
                return false;
            }
            if (/^(.)\1+$/.test(fphone)) {
                jQuery('.invalid-number').text(errormsg);
                jQuery('.form__btn').attr('disabled', false).removeClass('loading');
                jQuery('.fa-spin').hide();
                return false;
            }
            if (fphone.length < 10) {
                errormsg = 'Please enter a 10-Digit Phone Number';
                jQuery('.invalid-number').text(errormsg);
                jQuery('.form__btn').attr('disabled', false).removeClass('loading');
                jQuery('.fa-spin').hide();
                return false;
            } else {
                if (fphone.length > 10) {
                    errormsg = 'Please enter a 10-Digit Phone Number';
                    jQuery('.invalid-number').text(errormsg);
                    jQuery('.form__btn').attr('disabled', false).removeClass('loading');
                    jQuery('.fa-spin').hide();
                    return false;
                } else {
                    var newphone = '(' + fphone.substring(0, 3) + ') ' + fphone.substring(3, 6) + ' - ' + fphone.substring(6);
                    jQuery('.phone_number', myForm).val(newphone);
                    jQuery('.invalid-number').empty();
                    return true;
                }
            }
        } else {
            errormsg = 'Please enter a 10-Digit Phone Number';
            jQuery('.invalid-number').text(errormsg);
            jQuery('.form__btn').attr('disabled', false).removeClass('loading');
            jQuery('.fa-spin').hide();
            return false;
        }
    }

    function validateLeadName(myForm)
    {

        var fname = $('#full-name', myForm).val(),
            lname = fname.split(' '),
            errormsg = '';

        if (fname.indexOf(' ') > -1) {
            if (fname.length < 3 || lname[1].length < 3) {
                errormsg = 'Please Enter Your First and Last Name';
                $('.invalid-name').text(errormsg);
                return false;
            } else {
                $('.invalid-name').empty();
                return true;
            }
        } else {
            errormsg = 'Please Enter Your First and Last Name';
            $('.invalid-name').text(errormsg);
            return false;
        }

    }

    function validateCertify(myForm)
    {

        var checkbox = $('#certify', myForm).is(':checked');

        if (!checkbox) {
            var errormsg = 'Please check that you certify the information.';
            $('.invalid-certify').text(errormsg);
            return false;
        } else {
            $('.invalid-certify').empty();
            return true;
        }

    }

    function validateZip(value)
    {

        var zipCodesList = window.formZipCodes ?? {};
        var reg = /(^\d{5}$)/;

        if (value.length < 5) {
            return false;
        } else if (!reg.test(value)) {
            return false;
        } else if (Object.values(zipCodesList).includes(value) === false) {
            return false;
        }

        return true;
    }

    function validateLeadEmail(myForm)
    {

        var $email = $('#email_address', myForm).val();
        var emailReg = /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,6})+$/;

        if (!emailReg.test($email)) {
            var errormsg = 'Please enter a valid email address.';
            $('.invalid-email').text(errormsg);
            return false;
        } else {
            $('.invalid-email').empty();
            return true;
        }

    }

    function replaceVars(text)
    {

        var fieldName = '',
            answer = '',
            answers = [];

        if (text.indexOf('[[zip]]') > -1) {
            text = text.replace('[[zip]]', zipCode);
        }

        if (text.indexOf('[[number]]') > -1) {
            text = text.replace('[[number]]', $('input#housing-num').val());
        }

        if (text.indexOf('[[answer2]]') > -1) {
            fieldName = window.leadFormData[2]['field'];

            answers = window.leadFormData[2]['answers'];

            answer = $leadForm.find('input#' + fieldName).val();

            if (answer === 'not_sure') {
                text = text.replace('[[answer2]]', 'Housing');
            } else {
                text = text.replace('[[answer2]]', answers[answer]['label']);
            }
        }

        if (text.indexOf('[[answer2-senior]]') > -1) {
            fieldName = window.leadFormData[2]['field'];

            answers = window.leadFormData[2]['answers'];

            answer = $leadForm.find('input#' + fieldName).val();

            if (answer === 'not_sure') {
                text = text.replace('[[answer2-senior]]', 'Senior Care');
            } else if (answer === 'nursing_home') {
                text = text.replace('[[answer2-senior]]', 'a ' + answers[answer]['label']);
            } else {
                text = text.replace('[[answer2-senior]]', answers[answer]['label']);
            }
        }

        if (text.indexOf('[[answer3]]') > -1) {
            fieldName = window.leadFormData[3]['field'];

            answer = $leadForm.find('input#' + fieldName).val();

            if (answer === 'Myself') {
                answer = 'for you';
            } else {
                answer = 'for your ' + answer.toLowerCase();
            }

            text = text.replace('[[answer3]]', answer);
        }

        if (text.indexOf('[[answer3-can]]') > -1) {
            fieldName = window.leadFormData[3]['field'];

            answer = $leadForm.find('input#' + fieldName).val();

            if (answer === 'Myself') {
                answer = 'you';
            } else {
                answer = 'they';
            }

            text = text.replace('[[answer3-can]]', answer);
        }

        if (text.indexOf('[[answer3-do]]') > -1) {
            fieldName = window.leadFormData[3]['field'];

            answer = $leadForm.find('input#' + fieldName).val();

            if (answer === 'Myself') {
                answer = 'do you';
            } else if (answer === 'OTHER_RELATIVE') {
                answer = 'does your other relative';
            } else {
                answer = 'does your ' + answer.toLowerCase();
            }

            text = text.replace('[[answer3-do]]', answer);
        }

        if (text.indexOf('[[answer4]]') > -1) {
            fieldName = window.leadFormData[4]['field'];

            answer = $leadForm.find('input#' + fieldName).val();

            text = text.replace('[[answer4]]', answer);
        }

        return text;

    }

    function shiftToNextStep(stepData, fieldValue, $stepNum)
    {

        $('#housing-lead__qa-question-subtext').fadeOut(300, function () {

            $(this).remove();

        });

        if (Object.prototype.hasOwnProperty.call(stepData, 'tip')) {
            $leadForm.find('#housing-lead__tip').fadeOut(300, function () {
                $('#housing-lead__tip-text').empty().html(stepData['tip']);
                $(this).fadeIn(300, function () {
                    $(this).css('display', 'flex');
                });
            });
        }

        $leadForm.find('#housing-lead__qa').fadeOut(300, function () {

            if ($('#housing-lead__qa-answers #housing-lead__final').length) {
                $('#housing-lead__qa-answers #housing-lead__final').removeClass('active no-details').insertAfter('#housing-lead__steps');
            }

            if ($('#housing-lead__qa-answers #housing-lead__low').length) {
                $('#housing-lead__qa-answers #housing-lead__low').removeClass('active').insertAfter('#housing-lead__steps');
            }

            if (Object.prototype.hasOwnProperty.call(stepData, 'question')) {
                var question = replaceVars(stepData['question']);

                $(this).find('#housing-lead__qa-question').empty().html(question).fadeIn(300);
            }

            var answers = '';

            for (var answer in stepData['answers']) {
                var checked = '';
                var checkedClass = '';

                if (fieldValue !== null && fieldValue === stepData['answers'][answer]['label']) {
                    checked = ' checked="checked"';
                    checkedClass = ' checked';
                }

                answers = answers.concat('' +
                    '<div class="step-answer" data-field="' + stepData['field'] + '">' +

                    '<input type="radio" id="question' + $stepNum + '"' + checked + ' value="' + answer + '" disabled="disabled" />' +

                    '<div class="square' + checkedClass + '">' +
                    '<div class="icon"><img src="' + stepData['answers'][answer]['icon'] + '" /></div>' +
                    '<div class="label">' + stepData['answers'][answer]['label'] + '</div>' +
                    '</div>' +

                    '</div>');
            }

            $(this).find('#housing-lead__qa-answers').empty().html(answers);

            $(this).find('#housing-lead__qa-image').empty().html('<img src="' + stepData['image'] + '" />');

            var count = $stepNum - 1;
            var totalCount = totalStepCount - 1;

            $leadForm.find('#housing-lead__steps-count span.num').text(count);
            var percentageTimes = 100 / (totalCount - 1);
            var percentage = percentageTimes * count;
            $leadForm.find('#housing-lead__steps-count-bar span').width(percentage + '%');

            $('#housing-lead').removeClass('low');

            if ($stepNum > 1) {
                $(this).addClass('after').removeClass('first');
            }

            $(this).fadeIn(300, function () {
                if ($('#housing-lead #housing-lead__container .loading-results').length) {
                    $('#housing-lead #housing-lead__container .loading-results').fadeOut(300, function () {
                        $(this).remove();
                    });
                }
                $('.step-answer input').removeAttr('disabled');
            });

        });

    }

    function phoneFormatter()
    {

        $('#phone_number').on('input', function () {

            var number = $(this).val().replace(/[^\d]/g, '')
            if (number.length == 7) {
                number = number.replace(/(\d{3})(\d{4})/, '$1 - $2');
            } else if (number.length == 10) {
                number = number.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2 - $3');
            } else if (number.length > 10) {
                number = number.slice(0, 10);
                number = number.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2 - $3');
            }

            $(this).val(number);

        });

    }

    const animatePBar = (cb) => {

        let progressBar = $('#housing-lead__qa .progress');
        let max = 100;
        let time = (2200 / max) * 1;
        let value = 0;

        const loading = () => {
            value += 1;
            progressBar.width(value + '%');
            if (value === max) {
                progressBar.width('100%');
                cb();
                clearInterval(animate);
            }
        };
        const animate = setInterval(() => loading(), time);

    };

    function showFinalForm(stepData)
    {

        var interest = $leadForm.find('input#interest').val();

        $leadForm.find('#housing-lead__steps-header-title').fadeOut(300, function () {

            var title = replaceVars(stepData['header']['title']);

            $(this).empty().html(title).fadeIn(300);

        });

        if ($leadForm.find('#housing-lead__steps-header-subtitle').is(':visible')) {
            $leadForm.find('#housing-lead__steps-header-subtitle').fadeOut(300);
        }

        $leadForm.find('#housing-lead__qa').fadeOut(300, function () {

            $(this).removeClass('progress-load').empty().html('<div id="housing-lead__qa-answers"></div>');

            if ($leadForm.find('.low-form-fields label').length) {
                $('.low-form p.h4').remove();

                $('.low-form').removeClass('finished');

                $leadForm.find('.low-form-fields label').each(function () {

                    $(this).insertBefore($('#housing-lead__final-fields #submit-btn-container'));

                });
            }

            if (Object.prototype.hasOwnProperty.call(stepData, 'question')) {
                var question = replaceVars(stepData['question']);

                $(this).find('#housing-lead__qa-question').empty().html(question);
            } else {
                $(this).find('#housing-lead__qa-question').hide();
            }

            $('#housing-lead__qa-question #housing-lead__qa-question-subtext').remove();

            if (interest === 'H') {
                $('<div id="housing-lead__qa-question-subtext">' + replaceVars(stepData['subtext-alt']) + '</div>').insertAfter($(this).find('#housing-lead__qa-question'));
            } else {
                $('<div id="housing-lead__qa-question-subtext">' + replaceVars(stepData['subtext']) + '</div>').insertAfter($(this).find('#housing-lead__qa-question'));
            }

            $(this).find('#housing-lead__qa-answers').empty();

            $('#housing-lead__final').addClass('active').prependTo($(this).find('#housing-lead__qa-answers'));

            $(this).fadeIn(300);

            if (typeof window.finalTip !== 'undefined' && window.finalTip !== '') {
                $leadForm.find('#housing-lead__tip').fadeOut(300, function () {
                    $('#housing-lead__tip-text').empty().html(window.finalTip);
                    $(this).fadeIn(300);
                });
            }

            $(phoneFormatter);

        });

    }

    function goToLowResult()
    {

        $leadForm.find('#housing-lead__steps-header-title').fadeOut(300, function () {

            $('#housing-lead').addClass('low');

            $(this).empty().html('Based on your selections we recommend some of these cost effective alternatives:').fadeIn(300);

        });

        $leadForm.find('#housing-lead__qa').fadeOut(300, function () {

            if ($leadForm.find('#housing-lead__final label').length) {
                $leadForm.find('#housing-lead__final label').each(function () {

                    $(this).appendTo($('.low-form-fields'));

                });
            }

            $(this).find('#housing-lead__qa-question').hide();

            $('#housing-lead__qa-question #housing-lead__qa-question-subtext').remove();

            $(this).find('#housing-lead__qa-answers').empty();

            $('#housing-lead__low').addClass('active').prependTo($(this).find('#housing-lead__qa-answers'));

            $(this).fadeIn(300);

            $(phoneFormatter);

            var $formClicked = false;

            $('#low-submit').on('click touchend', function () {

                if ($formClicked === false) {
                    $formClicked = true;

                    var phone = $leadForm.find('.phone_number').val(),
                        submitBtn = $(this);

                    $leadForm = $('#lead-form');

                    submitBtn.parent().addClass('processing');
                    submitBtn.prop('disabled', true);

                    $leadForm.find('.phone_number').val(function (v) {
                        return v.replace('+1', '');
                    });

                    $leadForm.find('#contact_phone').val(function () {

                        if (phone[0] == 1) {
                            phone = phone.slice(1);
                        }
                        return phone.replace(/\D/g, '');

                    });

                    var name = validateLeadName($leadForm),
                        phoneValid = validatePhone($leadForm),
                        email = validateLeadEmail($leadForm),
                        full_name = $leadForm.find('input#full-name').val(),
                        interest = $leadForm.find('input#interest').val(),
                        relationship_name = $leadForm.find('input#relationship_name').val(),
                        timeframe = $leadForm.find('input#timeframe').val(),
                        financial = $leadForm.find('input#financial').val(),
                        budget = $leadForm.find('input#budget').val();

                    if (name !== false && phoneValid !== false && email !== false) {
                        var $name = full_name.split(' ');
                        $leadForm.find('.first-name').val($name[0]);
                        $leadForm.find('.last-name').val($name[1]);
                        $leadForm.find('.phone_home').val(phone);
                        $leadForm.find('.city').val().replace('-1', '').replace('-2', '').replace('-3', '').replace('-4', '').replace(/-/g, ' ');
                        $leadForm.find('#careTypeCode').val(interest);
                        $leadForm.find('#relationToResident').val(relationship_name);
                        $leadForm.find('#moveDateRange').val(timeframe);
                        $leadForm.find('#financialResources').val(financial);

                        if (budget == '2000') {
                            $leadForm.find('#budgetMin').val(2000);
                            $leadForm.find('#budgetMax').val(2001);
                        } else {
                            $leadForm.find('#budgetMin').val(1);
                            $leadForm.find('#budgetMax').val(1999);
                        }

                        submitLytics($leadForm.serializeArray());

                        $.ajax({
                            url: 'https://love.leadspediatrack.com/post.do',
                            type: 'POST',
                            data: $leadForm.serialize(),
                            timeout: 5000,
                        }).done(function () {
                            const defaultData = {
                                'event': 'lead_form_submission',
                                'leadFormId': 'housing-finder-form',
                                'submissionStatus': 'success',
                                'errorReason': 'null',
                            };
                            window.dataLayer.push(defaultData);
                            console.log(defaultData);

                            $.post('/app/themes/tsl-base/inc/active-campaign.php', $leadForm.serialize(), function () {

                                $('.low-form').addClass('finished').prepend($('<p class="h4">Thank you! Someone will be in contact with you shortly.</p>').fadeIn(300));

                            });
                        }).fail(function (jqXHR, textStatus, errorThrown) {
                            console.log(textStatus, errorThrown, jqXHR);

                            submitBtn.parent().removeClass('processing');

                            submitBtn.prop('disabled', false);

                            // Update message on Error
                            $('.submit-error').empty().text('Something went wrong! Please try again later');
                        });
                    } else {
                        const defaultData = {
                            'event': 'lead_form_submission',
                            'leadFormId': 'housing-finder-form',
                            'submissionStatus': 'failure',
                            'errorReason': 'invalid field',
                        };
                        window.dataLayer.push(defaultData);
                        console.log(defaultData);
                        submitBtn.parent().removeClass('processing');

                        submitBtn.prop('disabled', false);

                        $formClicked = false;
                    }

                    return false;
                }

            });

        });


    }

    function goToNextStep($stepNum, fieldValue, final)
    {

        var stepData = window.leadFormData[$stepNum];

        $stepNum = parseInt($stepNum);

        zipCode = $('#zip_code').val();
        const interestValue = $leadForm.find('input#interest').val();
        const timeframeValue = $leadForm.find('input#timeframe').val();

        if (zipCode === '') {
            zipCode = $('.zipcode').val();
        }

        if ($stepNum === 1) {
            $('button#next').removeAttr('disabled');

            if (Object.prototype.hasOwnProperty.call(stepData, 'tip')) {
                $leadForm.find('#housing-lead__tip').fadeOut(300, function () {
                    $('#housing-lead__tip-text').empty().html(stepData['tip']);
                    $(this).fadeIn(300, function () {
                        $(this).css('display', 'flex');
                    });
                });
            }

            if (fieldValue !== 'firstLoad') {
                setTimeout(function () {

                    if ($leadForm.find('#housing-lead__steps-header-subtext').is(':visible')) {
                        $('#housing-lead__qa-question-subtext').fadeOut(function () {

                            $(this).remove();

                        });
                    } else {
                        $('#housing-lead__qa-question-subtext').remove();
                    }

                    $leadForm.find('#housing-lead__qa').addClass('first').fadeOut(function () {

                        if ($('#housing-lead__qa-answers #housing-lead__final').length) {
                            $('#housing-lead__qa-answers #housing-lead__final').removeClass('active no-details').insertAfter('#housing-lead__steps');
                        }

                        var question = replaceVars(stepData['question']);

                        $('#housing-lead__qa').removeClass('after');

                        $(this).find('#housing-lead__qa-question').empty().html(question).show();

                        $(this).find('#housing-lead__qa-answers').empty().html('' +

                            '<div id="zip-container">' +

                            '<label class="field-label" for="question' + $stepNum + '">' +

                            'Zip Code' +

                            '<input type="number" class="zipcode" required value="" oninput="this.value=this.value.slice(0,this.maxLength)"  maxlength="5" id="question' + $stepNum + '" />' +

                            '</label>' +

                            '<button id="next">Next</button>' +

                            '</div>');

                        $(this).fadeIn(300, function () {
                            if ($('#housing-lead #housing-lead__container .loading-results').length) {
                                $('#housing-lead #housing-lead__container .loading-results').fadeOut(300, function () {
                                    $(this).remove();
                                });
                            }
                        });

                    });

                }, 300);
            }
        } else if ($stepNum > 1 && $stepNum < totalStepCount && final !== true) {
            // Use DynamicCityAPIClient instead of OpenStreetMap
            if ($stepNum == 2) {
                $.ajax({
                    url: window.ajaxurl || window.site_settings?.admin_ajax,
                    type: 'POST',
                    data: {
                        action: 'validate_zip',
                        zip: zipCode,
                    },
                    success: function(response) {
                        console.log(response);
                        if (response && response.data && response.data.length > 0) {
                            const zipData = response.data[0];
                            const {
                                latitude,
                                longitude,
                                code,
                                cities: [{
                                    slug: cityName,
                                    state: {
                                        name: stateName,
                                    } = {},
                                } = {}],
                            } = zipData;

                            $('input#sgeo_lat').val(latitude || '');
                            $('input#sgeo_lon').val(longitude || '');
                            $('input.city').val(cityName || '');
                            $('input.state').val(stateName || '');
                            $('input#zip_code').val(code || '');
                        }
                    },
                    error: function(xhr, status, error) {
                        console.error('Zip validation error:', error);
                    },
                });
            }

            shiftToNextStep(stepData, fieldValue, $stepNum);
        } else {
            $leadForm.find('#housing-lead__qa').fadeOut(300, function () {

                $(this).addClass('progress-load');

                $(this).empty().html('<div class="progress-container">Analyzing your selections<div class="progress-bar"><span class="progress"></span></div></div><div class="loading-img"></div>');

                $(this).fadeIn(300);

            });

            $leadForm.find('#housing-lead__tip').fadeOut(300);
            $.get(window.ajaxurl, {
                action: 'get_listing_count',
                city: $('input.city').val(),
                state: $('input.state').val(),
                type: interestValue,
                timeframe: timeframeValue,
            }, function (data) {

                $('input#housing-num').val(data.number);
                $(document).trigger('isFinalStep');

            }, 'json').done(function () {

                animatePBar(() => {
                    showFinalForm(stepData)
                });

            });
        }

        setTimeout(function () {

            $leadForm.find('#housing-lead__step-icons a.step-icon-link').removeClass('active current');

            var activeDotCount = (final === true) ? 6 : $stepNum;
            activeDotCount = (final === 'wait') ? totalStepCount - 2 : activeDotCount;

            for (var i = 1; i < activeDotCount; i++) {
                var linkSpan = $('#housing-lead__step-icons  a[data-step="' + i + '"]');

                linkSpan.addClass('active');
            }

            $('#housing-lead__step-icons a[data-step="' + activeDotCount + '"]').addClass('current');

        }, 300);

        setTimeout(function () {

            $('#housing-lead').removeAttr('class');
            $('#housing-lead').addClass('step-' + $stepNum);

        }, 400);

        $('input#step-num').val($stepNum);

        if ($stepNum > 1 && $(window).width() <= 767) {
            $('html, body').animate({scrollTop: $('#housing-lead').offset().top}, 500);
        }

        var url = window.location.protocol + '//' + window.location.host + window.location.pathname + '?q=' + $stepNum;
        window.history.pushState({path: url}, '', url);

    }

    $(function () {

        var first_back_click = false;

        $('body').on('propertychange input', '.zipcode', forceNumeric);

        zipCode = $('input#zip_code').val();

        window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (a, name, value) {
            $_GET[name] = value;
        });

        $(document).on('click', '.step-answer input', function (e) {

            e.preventDefault();

            $('.step-answer input').attr('disabled', 'disabled');

            first_back_click = false;

            $leadForm.find('.step-answer input').prop('checked', false);
            $leadForm.find('.step-answer .square').removeClass('checked');

            $(this).prop('checked', true);

            var stepNum = parseInt($leadForm.find('input#step-num').val()),
                stepData = window.leadFormData[stepNum],
                checkedField = $leadForm.find('input[id="question' + stepNum + '"]:checked'),
                fieldID = checkedField.parent().data('field'),
                checkedValue = checkedField.val(),
                visitedURL = false,
                retURL = $leadForm.find('.retURL').val(),
                startingURL = $leadForm.find('.starting_url').val(),
                urls = Object.keys(window.haystackURLs).map(function (item) {
                    return window.haystackURLs[item];
                });

            $(this).next().addClass('checked');

            if ($.inArray(retURL, urls) !== -1) {
                visitedURL = true;
            } else if ($.inArray(startingURL, urls) !== -1) {
                visitedURL = true;
            }

            if (fieldID === 'cost') {
                $leadForm.find('input#budget').val(checkedValue);

                if (checkedValue === '1999' && visitedURL === true) {
                    $leadForm.find('input#' + fieldID).val('low');
                } else if (checkedValue === '2000' && visitedURL === true) {
                    $leadForm.find('input#' + fieldID).val('unset');
                } else {
                    $leadForm.find('input#' + fieldID).val('unset');
                }
            } else {
                $leadForm.find('input#' + fieldID).val(checkedValue);
            }


            if (checkedValue === 'N' || checkedValue === 'Z') {
                $('#housing-lead__low').addClass('no-advisor');
            } else {
                $('#housing-lead__low').removeClass('no-advisor');
            }


            if (checkedValue === 'P' || checkedValue === 'R') {
                $('#housing-lead__low').addClass('no-form');
            } else {
                $('#housing-lead__low').removeClass('no-form');
            }

            if (typeof stepData['goToForm'] !== 'undefined') {
                triggerTrackingSteps(stepNum + 1, 'forward');
                goToNextStep(stepNum + 1, null, 'wait');
            } else if ($leadForm.find('input#interest').val() === 'H') {
                setTimeout(function () {
                    triggerTrackingSteps(totalStepCount, 'forward');
                    goToNextStep(totalStepCount, 'H', true);
                }, 100);
            } else {
                if (stepNum < totalStepCount) {
                    var final = false;

                    if (typeof stepData['followup'] !== 'undefined') {
                        final = true;
                    }

                    if ($leadForm.find('input#cost').val() === 'low' && final === true) {
                        triggerTrackingSteps(totalStepCount, 'forward');
                        goToLowResult();
                    } else {
                        setTimeout(function () {

                            triggerTrackingSteps(stepNum + 1, 'forward');
                            goToNextStep(stepNum + 1, null, final);

                        }, 100);
                    }
                }
            }

        });

        $(document).on('click', 'a.step-icon-link', function (e) {

            e.preventDefault();

            if ($(this).hasClass('active')) {
                var step = $(this).data('step'),
                    stepData = window.leadFormData[step],
                    url = window.location.protocol + '//' + window.location.host + window.location.pathname + '?q=' + step,
                    fieldName = stepData['field'],
                    fieldValue = $leadForm.find('input#' + fieldName).val();

                $('input#step-num').val(step);

                window.history.pushState({path: url}, '', url);

                goToNextStep(step, fieldValue);

                if (step === 3 || step === 2) {
                    $(document).ajaxStop(function () {

                        setTimeout(function () {

                            $('#housing-lead__steps').removeClass('final');

                        }, 300);

                    });
                } else {
                    setTimeout(function () {

                        $('#housing-lead__steps').removeClass('final');

                    }, 300);
                }
            }

        });

        $(document).on('click', 'button#next', function (e) {

            e.preventDefault();

            var $value = $('#zip-container input').val(),
                button = $(this);
            button.prop('disabled', true);
            $('#zip-container label').removeClass('error');
            $('#zip-container').addClass('processing');

            if (!validateZip($value)) {
                $('#zip-container label').addClass('error');
                $('#zip-container').removeClass('processing');
                button.removeAttr('disabled');
            } else {
                var step = parseInt($leadForm.find('input#step-num').val()),
                    stepData = window.leadFormData[step],
                    url = window.location.protocol + '//' + window.location.host + window.location.pathname + '?q=' + step,
                    fieldName = stepData['field'],
                    fieldValue = $('input#question1').val(),
                    nextStep = step + 1;

                zipCode = fieldValue;

                $leadForm.find('input#' + fieldName).val(fieldValue);

                if (fieldName === 'zip_code') {
                    $leadForm.find('input#care_location').val(fieldValue);
                }

                $('input#step-num').val(step);

                window.history.pushState({path: url}, '', url);

                triggerTrackingSteps(nextStep, 'forward');
                goToNextStep(nextStep, fieldValue);
            }

        });

        var leadform_clicked = false;

        $('#submit-btn-container input').on('click touchend', function (e) {

            e.preventDefault();

            e.stopImmediatePropagation();

            if (leadform_clicked === false) {
                leadform_clicked = true;

                var phone = $leadForm.find('.phone_number').val(),
                    submitBtn = $(this);

                $leadForm = $('#lead-form');

                submitBtn.parent().addClass('processing');
                submitBtn.prop('disabled', true);

                $leadForm.find('.phone_number').val(function (i, v) {
                    return v.replace('+1', '');
                });

                $leadForm.find('#contact_phone').val(function () {

                    if (phone[0] == 1) {
                        phone = phone.slice(1);
                    }
                    return phone.replace(/\D/g, '');

                });

                var name = validateLeadName($leadForm),
                    phoneValid = validatePhone($leadForm),
                    email = validateLeadEmail($leadForm),
                    certify = validateCertify($leadForm),
                    full_name = $leadForm.find('input#full-name').val(),
                    interest = $leadForm.find('input#interest').val(),
                    relationship_name = $leadForm.find('input#relationship_name').val(),
                    timeframe = $leadForm.find('input#timeframe').val(),
                    financial = $leadForm.find('input#financial').val(),
                    budget = $leadForm.find('input#budget').val();

                if (name !== false && phoneValid !== false && email !== false && certify !== false) {
                    var $name = full_name.split(' ');
                    $leadForm.find('.first-name').val($name[0]);
                    $leadForm.find('.last-name').val($name[1]);
                    $leadForm.find('.phone_home').val(phone);
                    $leadForm.find('.city').val().replace('-1', '').replace('-2', '').replace('-3', '').replace('-4', '').replace(/-/g, ' ');
                    $leadForm.find('#careTypeCode').val(interest);
                    $leadForm.find('#relationToResident').val(relationship_name);
                    $leadForm.find('#moveDateRange').val(timeframe);
                    $leadForm.find('#financialResources').val(financial);

                    if (budget == '2000') {
                        $leadForm.find('#budgetMin').val(2000);
                        $leadForm.find('#budgetMax').val(2001);
                    } else {
                        $leadForm.find('#budgetMin').val(1);
                        $leadForm.find('#budgetMax').val(1999);
                    }

                    submitLytics($leadForm.serializeArray());

                    $.ajax({
                        url: 'https://love.leadspediatrack.com/post.do',
                        type: 'POST',
                        data: $leadForm.serialize(),
                        timeout: 5000,
                    }).done(function () {
                        const defaultData = {
                            'event': 'lead_form_submission',
                            'leadFormId': 'housing-finder-form',
                            'submissionStatus': 'success',
                            'errorReason': 'null',
                        };
                        window.dataLayer.push(defaultData);
                        console.log(defaultData);

                        $.post('/app/themes/tsl-base/inc/active-campaign.php', $leadForm.serialize(), function () {

                            const resultsNum = $('#housing-num').val();
                            if(resultsNum > 0) {
                                $leadForm.submit();
                            }else {
                                $('#housing-lead__final-fields, #housing-lead__final .final-header, #housing-lead__final #submit-btn-container, #housing-lead__final #disclaimer').fadeOut(300, function() {
                                    let firstName = $leadForm.find('.first-name').val();
                                    $('#housing-lead__final .final-thank-you .final-thank-you-title .first-name').html(firstName);
                                    $('#housing-lead__final .final-thank-you').show();
                                });
                            }

                        });
                    }).fail(function (jqXHR, textStatus, errorThrown) {
                        console.log(textStatus, errorThrown, jqXHR);

                        submitBtn.parent().removeClass('processing');

                        submitBtn.prop('disabled', false);

                        // Update message on Error
                        $('.submit-error').empty().text('Something went wrong! Please try again later');
                    });
                } else {
                    const defaultData = {
                        'event': 'lead_form_submission',
                        'leadFormId': 'housing-finder-form',
                        'submissionStatus': 'failure',
                        'errorReason': 'invalid field',
                    };
                    window.dataLayer.push(defaultData);
                    console.log(defaultData);

                    leadform_clicked = false;

                    submitBtn.parent().removeClass('processing');

                    submitBtn.prop('disabled', false);
                }
            }

        });

        if ($('#housing-lead').length) {
            var zipCode = $('input#zip_code').val(),
                step = 0,
                fieldValue = '',
                direction = '';

            if (typeof $_GET['type'] !== 'undefined') {
                step = $_GET['q'];
            } else if (zipCode != '') {
                if (!validateZip(zipCode)) {
                    step = 1;
                    fieldValue = 'noResults';
                } else {
                    if (!$('#housing-lead #housing-lead__container .loading-results').length) {
                        $('#housing-lead #housing-lead__container').prepend('<div class="loading-results active">Loading housing finder...</div>');
                    }
                    step = 2;
                }
                direction = fieldValue !== '' ? 'reverse' : 'forward';
            } else {
                step = 1;
                direction = 'forward';
                fieldValue = 'firstLoad';

                $('#housing-lead').addClass('step-0');
            }

            triggerTrackingSteps(step, direction);
            goToNextStep(step, fieldValue);

            $('.back-btn').on('click', function (e) {
                e.preventDefault();

                window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (a, name, value) {
                    $_GET[name] = value;
                });

                var step = parseInt($_GET['q']) - 1;

                triggerTrackingSteps(step, 'reverse');
                goToNextStep(step);

            });

            window.addEventListener('popstate', function () {

                window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (a, name, value) {
                    $_GET[name] = value;
                });

                var minus = 0;

                if (first_back_click !== false) {
                    minus = 1;
                }

                var step = parseInt($_GET['q']) - minus,
                    url = window.location.protocol + '//' + window.location.host + window.location.pathname + '?q=' + step,
                    referrer = document.referrer;

                triggerTrackingSteps(step, 'reverse');

                window.history.pushState({path: url}, '', url);

                window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (a, name, value) {
                    $_GET[name] = value;
                });

                step = parseInt($_GET['q']);

                $leadForm.find('#housing-lead__qa').fadeOut(300, function () {

                    $('#housing-lead__final').removeClass('no-details active').appendTo('#lead-form');

                    if (!$('#housing-lead #housing-lead__container .loading-results').length) {
                        $('#housing-lead #housing-lead__container').prepend('<div class="loading-results active">Loading housing finder...</div>');
                    }

                    $(this).empty().removeClass('progress-load');

                    $(this).html('<div id="housing-lead__qa-image"></div>\n' +
                        '<div id="housing-lead__qa-container">\n' +
                        '    <div id="housing-lead__steps-count">\n' +
                        '        <div id="housing-lead__steps-count-bar">\n' +
                        '            <span></span>\n' +
                        '        </div>\n' +
                        '        <div id="housing-lead__steps-count-num">\n' +
                        '            <span class="num"></span>/5\n' +
                        '        </div>\n' +
                        '    </div>\n' +
                        '    <div id="housing-lead__qa-question"></div>\n' +
                        '    <div id="housing-lead__qa-answers"></div>\n' +
                        '    <div class="form-footer">\n' +
                        '        <a href="#" class="back-btn">&larr; Back</a>\n' +
                        '    </div>\n' +
                        '</div>');

                    if (step > 0) {
                        goToNextStep(step);
                    } else {
                        if (typeof referrer !== 'undefined') {
                            window.location.href = document.referrer;
                        } else {
                            goToNextStep(1);
                        }
                    }

                    first_back_click = true;

                });

            });
        }

        $(document).on('isFinalStep', function () {

            function executeLogic() {
                const resultsNum = $('#housing-num').val(),
                    finalContainer = $('#housing-lead__final'),
                    finalSteps = $('#housing-lead__steps')

                $('#housing-lead__final .results-num span').empty().html(resultsNum);

                if (resultsNum > 0) {
                    finalContainer.removeClass('no-details');

                    if (!finalSteps.hasClass('loaded')) {
                        finalSteps.addClass('loaded');
                        $('#housing-lead__steps-header-title, #housing-lead__qa-question-subtext').empty();
                        finalContainer.wrapInner('<div class="lead-form"></div>').prepend('<div class="details"></div>');
                    }

                    let btn_text = 'See Local Assisted Living';

                    var living_type = 'Senior Housing';

                    if (typeof $_GET['b'] !== 'undefined') {
                        btn_text = 'Get free assistance';
                    }

                    if (btn_text !== '') {
                        $('#housing-lead__final #submit-btn-container input').val(btn_text);
                        $('#housing-lead__final #disclaimer .btn-text').empty().text(btn_text);
                    }

                    const $html = '<div id="housing-lead__steps-final-header-title">You’ll get these FREE resources:</div>'
                        + '<ul>'
                        + '<li><strong>FREE</strong> downloadable list of the <span>' + resultsNum + ' ' + living_type + '</span> options in your area.</li>'
                        + '<li><strong>FREE</strong> expert guidance from a local ' + living_type + ' Advisor.</li>'
                        + '</ul>';

                    $('#housing-lead__final .details').empty().html($html);

                } else {
                    finalContainer.addClass('no-details');
                    $('#housing-lead__final .final-header').html('<span>Please confirm your personal info to get <b>FREE expert guidance from a local senior advisor</b></span>');
                    $('#housing-lead__final #submit-btn-container input').val('Get Free Resources »');
                    $('#housing-lead__final #disclaimer .btn-text').empty().text('Get Free Resources');
                }
            }

            setTimeout(executeLogic, 400);

        });

    });


})(jQuery);
